import React, { useEffect, useState, useRef } from "react";

const AudioPlayer = ({ src, state, callId, setDuration }) => {
  const [error, setError] = useState(false);
  const [key, setKey] = useState(0);
  const audioRef = useRef(null);

  const handleError = () => {
    setError(true);
  };

  useEffect(() => {
    if (state === "ended") {
      setError(false);
    }
    setKey((prev) => prev + 1);
  }, [state]);

  return (
    <div className="audio-player-wrapper" key={key}>
      {error || state !== "ended" ? (
        <span style={{ color: "#ef4444", fontSize: "12px" }}>
          Audio Recording not available
        </span>
      ) : (
        <audio
          id={`audio-${callId}`}
          ref={audioRef}
          controls
          src={src}
          onError={handleError}
          onLoadedMetadata={() => {
            setDuration(
              audioRef.current.duration
                ? Math.floor(audioRef.current.duration)
                : null,
            );
          }}
          // The attribute below helps browsers understand
          // this should start from the beginning
          preload="metadata"
        />
      )}
    </div>
  );
};

export default AudioPlayer;
